export const isMobile = () => typeof window !== 'undefined' && window.innerWidth < 1024;

export const isTouchDevice = () => {
  const prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');
  const mq = (query) => window.matchMedia(query).matches;
  // eslint-disable-next-line no-mixed-operators, no-undef
  if (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch) {
    return true;
  }
  const query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
  return mq(query);
};

export const flatAndSort = (object, key) => {
  const keys = Object.keys(object);
  const sortedKeys = keys.sort((a, b) => object[a][key] - object[b][key]);
  const sortedObject = [];
  sortedKeys.forEach((k) => sortedObject.push({ key: k, ...object[k] }));
  return sortedObject;
};

/* eslint-disable arrow-body-style */
export const isSafari = () => {
  return typeof navigator !== 'undefined' && navigator.vendor && navigator.vendor.indexOf('Apple') > -1
  && navigator.userAgent
  && navigator.userAgent.indexOf('CriOS') === -1
  && navigator.userAgent.indexOf('Chrome') === -1
  && navigator.userAgent.indexOf('FxiOS') === -1;
};
/* eslint-enable */

export const isIOS = () => !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);

export const isEdge = () => typeof window !== 'undefined' && window.navigator.userAgent.indexOf('Edge') > -1;

export const isRetina = () => window.devicePixelRatio > 1;

export const inApp = () => document.location.href.match(/lang=/gi) !== null;

export const isLogged = () => document.location.href.match(/userId=/gi) !== null;

export const inFullpage = () => document.location.href.match(/fullPage=true/gi);

export const getLang = () => {
  let m;

  if (inApp()) {
    m = document.location.href.match(/lang=(en|fr|es|it|de|jp|zh-Hans|kr)?/i);
  } else {
    const userLang = navigator.language || navigator.userLanguage;
    m = userLang.match(/(en|fr|es|it|de|jp|zh|kr)/i);
  }

  return m ? m[1] : 'en';
};

export const lerp = (a, b, n) => ((1 - n) * a) + (n * b);

/* eslint-disable quote-props, no-nested-ternary */
export const sendGAEvent = (action, label) => {
  console.log(`Sending GAEvent: %c${action} %c: %c${label}`, 'color: red', 'color: black', 'color: blue');
  const dataLayer = window.dataLayer || [];
  dataLayer.push({
    'event': 'generic_event',
    'eventCategory': inApp() ? 'app' : isMobile() ? 'mobile' : 'desktop',
    'eventAction': action,
    'eventLabel': label,
  });
};
/* eslint-enable */

/* eslint-disable no-unused-vars, no-restricted-properties */
export const calcPerf = () => {
  const PERF_BAD = 0;
  const PERF_LOW = 1;
  const PERF_GOOD = 2;
  const PERF_HIGH = 3;
  let PERF = PERF_BAD;

  const getPerfs = () => {
    let array = [];
    const start = (window.performance || Date).now();
    for (let i = 0; i < 20000; i += 1) {
      array = Math.pow(Math.sin(Math.random()), 2);
    }
    const end = (window.performance || Date).now();
    return end - start;
  };

  const timing = getPerfs();
  if (timing < 7) PERF = PERF_HIGH;
  else if (timing < 14) PERF = PERF_GOOD;
  else if (timing < 22) PERF = PERF_LOW;
  else PERF = PERF_BAD;
  return PERF;
};

export const getUrlParam = (urlParam) => {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);

  return urlParams.get(urlParam);
};
